<template>
    <state-wrapper :state="state">
        <template v-slot:error>
            <div class="row">
                <div class="col-md-8 col-lg-9">
                    <alert type="danger">
                        <template v-slot:title>
                            Something went wrong
                        </template>
                        <p>
                            Sorry, there is a problem fetching announcements
                            right now.
                        </p>
                        <p>
                            We are working hard to resolve this issue, please
                            check back later.
                        </p>
                    </alert>
                </div>
            </div>
        </template>
        <div id="announcementsList">
            <div class="d-flex small mb-3">
                <span>{{ total_posts }} items</span>
                <span class="ml-auto"
                    >Sorting by: Updated (newest - oldest)</span
                >
            </div>
            <ul class="block-list">
                <item
                    v-for="{
                        ID,
                        post_title,
                        permalink,
                        summary,
                        image,
                    } in post_objects"
                    v-bind="{
                        ID,
                        post_title,
                        permalink,
                        summary,
                        image,
                    }"
                    :key="`announcement-${ID}`"
                />
            </ul>
            <pagination
                :totalPages="total_pages"
                :page="page"
                v-if="total_pages > 1"
                @changePage="changePage"
            />
        </div>
    </state-wrapper>
</template>

<script>
import StateWrapper from './components/StateWrapper.vue';
import Alert from './components/Alert.vue';
import Pagination from './components/Pagination.vue';
import Item from './list/Item.vue';

export default {
    name: 'App',
    components: {
        StateWrapper,
        Alert,
        Pagination,
        Item,
    },
    data() {
        return {
            state: 'idle',
            total_pages: 0,
            total_posts: 0,
            posts_per_page: 10,
            post_objects: [],
            page: 1,
        };
    },
    computed: {
        apiURL() {
            let url = `${
                process.env.VUE_APP_ENV_FILE === 'local'
                    ? 'https://mississauga.test'
                    : ''
            }/miway-transit/wp-json/com/v1/lists/announcements/`;
            const query = [];

            if (this.page > 1) query.push(`current_page=${this.page}`);
            if (this.posts_per_page !== 10)
                query.push(`posts_per_page=${this.posts_per_page}`);
            if (query.length > 0) url += `?${query.join('&')}`;

            return url;
        },
    },
    methods: {
        getList() {
            this.updateState('loading');
            fetch(this.apiURL)
                .then((resp) => resp.json())
                .then(
                    ({
                        total_pages,
                        total_posts,
                        posts_per_page,
                        post_objects,
                    }) => {
                        this['total_pages'] = total_pages;
                        this['total_posts'] = total_posts;
                        this['posts_per_page'] = posts_per_page;
                        this['post_objects'] = post_objects;
                        this.updateState('loaded');
                    }
                )
                .catch((err) => {
                    console.error(err);
                    this.updateState('error');
                });
        },
        updateState(newState) {
            this.state = newState;
        },
        changePage(page) {
            if (this.total_pages < page) return;
            const query = window.urlQueryString;

            this.page = page;

            if (page === 1) delete query.current_page;
            else query.current_page = [page];

            window.urlQueryString = query;

            this.getList();
        },
    },
    beforeMount() {
        const query = window.urlQueryString;
        if (query.current_page) this.page = query.current_page[0];
        if (query.posts_per_page) this.posts_per_page = query.current_page[0];
        this.getList();
    },
};
</script>

<style lang="scss">
@import 'styles/index';
</style>
